import { stringify } from 'qs'
import { useRecoilValue } from 'recoil'
import { ContractResponse, ContractsResponse, GetContractsRequestValue } from '../models/contractsModel'
import { idTokenState } from '../states/atoms'
import { API, useSWR } from './apiClient'

const BASE_URL = '/mi/contracts'

export const getContracts = (params: GetContractsRequestValue) => {
  const { idToken, isTokenRequested } = useRecoilValue(idTokenState)

  return useSWR<ContractsResponse | string>(`${BASE_URL}?${stringify(params)}`, idToken)
}

export const getContract = (id: string, idToken: string): Promise<ContractResponse> => {
  return API.get(`${BASE_URL}/${id}`, {
    headers: { Authorization: idToken },
  })
}
